import { Box } from "@mui/material";

export default function FullHeightContent({ children }: any) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  );
}